import {useRouter} from 'next/router';

import Input from '@/_application/core/components/ui/forms/input';
import {Button} from '@kidslabs/mario-ui-nextjs-react-core';
import {useTranslation} from 'next-i18next';
import {useModalAction} from '@/_application/core/components/ui/modal/modal.context';
import {Form} from '@/_application/core/components/ui/forms/form';
import type {RegisterUserInput} from '@/_application/core/types';
import * as yup from 'yup';

const registerFormSchema = yup.object().shape({
    name: yup.string().required('error-name-required'),
    email: yup.string().email('error-email-format').required('error-email-required'),
    //password: yup.string().required('error-password-required'),
});

function RegisterForm({onRegister}: {readonly onRegister: (input: RegisterUserInput) => void}) {
    const {t} = useTranslation('common');

    return (
        <>
            <Form<RegisterUserInput> onSubmit={onRegister} validationSchema={registerFormSchema}>
                {({register, formState: {errors}}) => (
                    <>
                        <Input
                            label={t('text-name')}
                            {...register('name')}
                            variant="outline"
                            className="mb-5"
                            error={t(errors.name?.message!)}
                            aria-label="Tên"
                        />
                        <Input
                            label={t('text-email')}
                            {...register('email')}
                            type="email"
                            variant="outline"
                            className="mb-5"
                            error={t(errors.email?.message!)}
                            aria-label="Email Input"
                        />
                        {/* <PasswordInput
              label={t('text-password')}
              {...register('password')}
              error={t(errors.password?.message!)}
              variant="outline"
              className="mb-5"
            /> */}
                        <div className="mt-8">
                            <Button aria-label="Đăng kí" className="h-12  w-full bg-primary hover:bg-blue-kid!">
                                {t('text-register', 'Đăng ký')}
                            </Button>
                        </div>
                    </>
                )}
            </Form>
            {/* End of forgot register form */}
        </>
    );
}
export default function RegisterView({onRegister}: {readonly onRegister: (input: RegisterUserInput) => void}) {
    const {t} = useTranslation('common');
    const router = useRouter();
    const {closeModal} = useModalAction();
    function handleNavigate(path: string) {
        router.push(`/${path}`);
        closeModal();
    }

    return (
        <div className="flex h-full w-full flex-col justify-center bg-primary-0 px-5 sm:p-8 md:h-auto md:min-h-0 md:max-w-[480px] md:rounded-xl">
            <div className="mb-7 mt-4 px-2 text-center text-sm leading-relaxed text-body sm:mb-10 sm:mt-5 sm:px-0 md:text-base">
                <p>
                    {t('registration-helper')}
                    <span
                        onClick={() => handleNavigate('quy-dinh-doi-tra-hang')}
                        className="mx-1 cursor-pointer text-accent underline hover:no-underline">
                        {t('text-terms')}
                    </span>
                </p>

                <p>
                    {t('text-and')}
                    <span
                        onClick={() => handleNavigate('chinh-sach-bao-mat')}
                        className="cursor-pointer text-accent underline hover:no-underline ltr:ml-1 rtl:mr-1">
                        {t('text-policy')}
                    </span>
                    &nbsp;{t('text-our')}
                </p>
            </div>

            <div className="item-center flex w-full flex-col content-center  justify-center">
                <RegisterForm onRegister={onRegister} />
            </div>
        </div>
    );
}
